import React, { useState } from 'react';

/**
 * Modal para generar informe firmado de una orden de trabajo
 *
 * @param {Object} props
 * @param {boolean} props.open - Si el modal está visible
 * @param {Object} props.item - Orden de trabajo seleccionada
 * @param {Function} props.onConfirm - Callback al confirmar (recibe observaciones)
 * @param {Function} props.onClose - Callback al cerrar
 * @param {boolean} props.loading - Si está generando el informe
 * @returns {JSX.Element|null}
 */
function GenerarInformeModal({ open, item, onConfirm, onClose, loading }) {
  const [observaciones, setObservaciones] = useState('');

  if (!open) return null;

  const handleClose = () => {
    if (!loading) {
      setObservaciones('');
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm(observaciones);
    setObservaciones('');
  };

  return (
    <div className="modal-backdrop" onClick={handleClose}>
      <div className="modal-container" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-header-content">
            <i className="fas fa-file-signature modal-icon-confirm" />
            <h3 className="modal-title">Generar Informe de Mantención</h3>
          </div>
          <button
            className="modal-close-btn"
            onClick={handleClose}
            disabled={loading}
          >
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="modal-body">
          <p>
            Se generará un informe oficial para la OT{' '}
            <strong>{item?.codigo_ot}</strong>, firmado electrónicamente
            con tu identidad. El informe incluirá todas las actividades y evidencias fotográficas
            registradas. Válido conforme a la Ley N° 19.799.
          </p>
          <div className="form-group">
            <label className="form-label">Observaciones finales (opcional)</label>
            <textarea
              className="form-textarea"
              rows={4}
              value={observaciones}
              onChange={e => setObservaciones(e.target.value)}
              placeholder="Descripción del trabajo realizado, materiales usados, novedades, etc."
              disabled={loading}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading
              ? <><i className="fas fa-spinner fa-spin" /> Generando...</>
              : <><i className="fas fa-file-signature" /> Firmar y descargar</>}
          </button>
        </div>
      </div>
    </div>
  );
}

export default GenerarInformeModal;
